import React from 'react'
import CustomSearch from '../../components/common/CustomSearch'
import Grid from '../../components/layout/grid/Grid'
import CustomSwitch from '../../components/common/CustomSwitch'

const Tabs = () => {
  return (
    <div>
        
        <Grid container className="flex m-2">
            <Grid item xs={6} className="border border-[#E2EBF3] rounded-md m-2">
                <div className='flex items-center justify-start p-2'>
                <CustomSwitch
                name="leads"
                /> 
                <span className='ml-2 font-semibold'>Leads</span>

                </div>
            </Grid>
            <Grid item xs={6} className="border border-[#E2EBF3] rounded-md m-2">
                <div className='flex items-center justify-start p-2'>
                <CustomSwitch
                name="dashboard"
                /> 
                <span className='ml-2 font-semibold'>Dashboard</span>

                </div>
            </Grid>
            <Grid item xs={6} className="border border-[#E2EBF3] rounded-md m-2">
                <div className='flex items-center justify-start p-2'>
                <CustomSwitch
                name="products"
                /> 
                <span className='ml-2 font-semibold'>Products</span>

                </div>
            </Grid>
            <Grid item xs={6} className="border border-[#E2EBF3] rounded-md m-2">
                <div className='flex items-center justify-start p-2'>
                <CustomSwitch
                name="learning"
                /> 
                <span className='ml-2 font-semibold'>Learning</span>

                </div>
            </Grid>
            <Grid item xs={6} className="border border-[#E2EBF3] rounded-md m-2">
                <div className='flex items-center justify-start p-2'>
                <CustomSwitch
                name="invoices"
                /> 
                <span className='ml-2 font-semibold'>Invoices</span>

                </div>
            </Grid>
        </Grid>
    </div>
  )
}

export default Tabs